import cn from "classnames";

import { openSans } from "@/app/font";
import type { MedicalAlertSystemSection as MedicalAlertSystemSectionType } from "@/sanity.types";

import { CarouselCentered } from "../carouselCentered/carouselCentered.component";
import { RichText } from "../richText/richText.component";
import { MedicalAlertSystemItem } from "./medicalAlertSystemItem.component";

export const MedicalAlertSystemSection = ({
  block,
}: MedicalAlertSystemSectionProps) => {
  const renderItems = () => {
    if (!block.items || !block.items.length) return null;
    return block.items.map((item) => (
      <MedicalAlertSystemItem
        key={item._key}
        title={item.title}
        description={item.description}
        icon={item?.icon}
      />
    ));
  };

  return (
    <section className={cn(openSans.className, "bg-primary-100 w-full")}>
      <div className="container mx-auto">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center gap-8 px-6 py-10 sm:px-10 md:px-16 lg:px-[163px]">
          <div className="w-full pt-1 text-center">
            {block.title ? (
              <h2 className="text-greyscale-headline text-3xl leading-tight font-bold md:text-[40px]">
                {block.title}
              </h2>
            ) : null}
            <div className="mx-auto mt-4 max-w-[680px]">
              <RichText>{block.subTitle}</RichText>
            </div>
          </div>

          <div className="w-full">
            <div className="hidden lg:grid lg:grid-cols-3 lg:gap-16">
              {renderItems()}
            </div>

            {block.legalDisclaimer ? (
              <div className="hidden lg:grid lg:grid-cols-3 lg:gap-16">
                <div className="text-center">
                  <RichText>{block.legalDisclaimer}</RichText>
                </div>
              </div>
            ) : null}

            <div className="rounded-2xl bg-white px-4 py-8 shadow-sm lg:hidden">
              <CarouselCentered
                mobileSlidesPerView={1}
                mobileSpaceBetween={24}
                centeredSlides
                initialSlide={0}
                showNavigation
                slidesFooter={
                  <div className="mt-4 text-center">
                    <RichText>{block.legalDisclaimer}</RichText>
                  </div>
                }>
                {renderItems()}
              </CarouselCentered>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export type MedicalAlertSystemSectionProps = {
  block: MedicalAlertSystemSectionType;
};
